import cookies from "browser-cookies"

// TODO Ensure the log rocket parameters are read from the environment, like the cookie-domain?!
const COOKIE_DOMAIN = process.env.GATSBY_COOKIE_DOMAIN
const LOG_ROCKET_SAMPLE = 100
const LOG_ROCKET_COOKIE_NAME = "lre7p7ly1en2"
const LOG_ROCKET_LIBRARY_MIN_JS_SRC = "https://cdn.lr-in.com/LogRocket.min.js"
const LOG_ROCKET_PAGE_OVERRIDES = {
  "/save/quote-offers/": 25, // enable 25% of the sessions to be recorded for new quote offers page.
}

let logRocketSamplerId =
  cookies.get(LOG_ROCKET_COOKIE_NAME) ||
  `LRS_${Math.floor(Math.random() * LOG_ROCKET_SAMPLE + 1)}`

if (
  Object.keys(LOG_ROCKET_PAGE_OVERRIDES).includes(window.location?.pathname)
) {
  const logRocketSamplerIdNumber = logRocketSamplerId.split("_")[1]
  if (
    logRocketSamplerIdNumber >
    100 - LOG_ROCKET_PAGE_OVERRIDES[window.location.pathname]
  )
    logRocketSamplerId = "LRS_100"
}

if (
  logRocketSamplerId.charAt(4) === "9" &&
  logRocketSamplerId.charAt(5) >= "5" // LRS_95+ -> so 95-100 will be recorded.
) {
  logRocketSamplerId = "LRS_100"
}
//end temp

cookies.set(LOG_ROCKET_COOKIE_NAME, logRocketSamplerId, {
  domain: COOKIE_DOMAIN,
  path: "/",
  expires: 1, // a day
})

let log_rocket_is_running = false

const isLogRocketLibraryLoaded = () => typeof window.LogRocket != "undefined"

const initializeLogRocket = () => {
  setTimeout(() => {
    if (isLogRocketLibraryLoaded() && !log_rocket_is_running) {
      window.LogRocket.init("pyembx/insurify", {
        dom: {
          inputSanitizer: true,
        },
      })
      log_rocket_is_running = true
    }
  }, 10)
}

const getLogRocketLibraryScriptTag = () => {
  const lrScript = document.createElement("script")
  lrScript.crossOrigin = "anonymous"
  lrScript.src = LOG_ROCKET_LIBRARY_MIN_JS_SRC
  lrScript.async = true
  lrScript.onload = initializeLogRocket
  return lrScript
}

const speedCurveTestsRunning = () =>
  window.navigator.userAgent.indexOf("PTST/SpeedCurve") !== -1

export const isLogRocketEnabled = () =>
  logRocketSamplerId === `LRS_${LOG_ROCKET_SAMPLE}` && !speedCurveTestsRunning()

export const LogRocketLibraryMinJs = getLogRocketLibraryScriptTag()
